module.exports = __webpack_public_path__ + "media/images/lb/556-61b52d9aeb1e690912471ba0f0f4a284.svg";